module.exports = __webpack_public_path__ + "img/user.1e84d45e.svg";